module.exports = __webpack_public_path__ + "img/cbl1r1.b89ee5fc.gif";